import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Link} from 'react-router-dom';
import {CSVLink} from 'react-csv';

import TransactionsSummary from './TransactionsSummary';
import AccountTransactions from './AccountTransactions';
import FundTransactions from './FundTransactions';
// import '../css/BalanceByAccount.css';
import '../css/TransactionHistory.css';

class TransactionHistory extends Component{
    style={
        backgroundColor: "#dedbde",
     }
    constructor(props){
        super(props)
        this.state = {
            startDate: moment().subtract(Number("1"), 'months').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            usrMemberSetId: this.props.match.params.usrMemberSetId,
            transactions: [],
            transactionsCSV: [],
            period: "1"
        }
        this.handleViewAndExport = this.handleViewAndExport.bind(this)
        this.exportRef = React.createRef();
    }

    static getDerivedStateFromProps(props, state){
        const transactions = props.transactions;

            return {
                transactions: transactions
            }
    }

    componentDidMount(){
        this.getTransactions(this.state);
        this.downloadMemberTransactions();
    }


    getTransactions(){
        this.props.startLoadingTransactions(this.state.usrMemberSetId, 
            moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD"))
            // .then(() => {this.setState({transactions: this.props.transactions})})
        
    }

    async downloadMemberTransactions(){
        await this.props.startDownloadingTransactionsCSV(this.state.usrMemberSetId,
            moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD"))
        const transactionsCSV = []
        if(this.props.transactionsHeader && this.props.transactionsDetails){
            transactionsCSV.push(this.props.transactionsHeader && this.props.transactionsHeader);
            this.props.transactionsDetails && this.props.transactionsDetails.map(detail => transactionsCSV.push(detail));
        }
        this.setState({transactionsCSV: transactionsCSV})
    }
    handleStartDate(date){
        this.setState({
            period: "-1",
            startDate: moment(date).format("YYYY-MM-DD"),
            endDate: this.state.endDate 
        })
    }

    handleEndDate(date){
        this.setState({
            period: "-1",
            startDate: this.state.startDate,
            endDate: moment(date).format("YYYY-MM-DD")
        })
    }

    handlePeriod(e) {
        // localStorage.set("period", e.target.value);
        if (e.target.value === "0") {
            this.setState({
                period: e.target.value,
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().add(1, 'month').format("YYYY-MM-DD")
            })
        }
        else if (e.target.value === "1" || e.target.value === "3" || e.target.value === "12") {
            this.setState({
                period: e.target.value,
                startDate: moment().subtract(Number(e.target.value), 'months').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            })
        }
        else if (e.target.value === "-1") {
            this.setState({
                period: e.target.value,
                startDate: this.state.startDate,
                endDate: this.state.endDate
            })
        }
    }

    handleViewAndExport(e){
        if(e.target.id === "view"){
            this.getTransactions();
        }else{ 
            this.getTransactions();
            this.downloadMemberTransactions().then(()=>{ 
                if (this.exportRef.current) this.exportRef.current.link.click()
                });;
        }
    }

    render(){
        const {t} = this.props
        let transactions = []
        
        if(this.state.transactions)
             transactions = Object.keys(this.state.transactions).map(key => this.state.transactions[key]);
        
        return(
            <div style={{marginTop: "20px", marginBottom: "20px"}}>
                <div  className="period">
                    <div style={{ display: "inline-block", fontSize: "14.6667px", fontFamily: "Roboto, sans-serif", color: "#333333" }}>{t('balanceByAccount:period')}</div>
                    <div className="radioButton"><input type="radio" id="0" name="period" value="0" checked={this.state.period === "0"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('transactions:currentMonth')}</div>
                    <div className="radioButton"><input type="radio" id="1" name="period" value="1" checked={this.state.period === "1"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('transactions:lastMonth')}</div>
                    <div className="radioButton"><input type="radio" id="3" name="period" value="3" checked={this.state.period === "3"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('transactions:threeMonths')}</div>
                    <div className="radioButton"><input type="radio" id="12" name="period" value="12" checked={this.state.period === "12"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('transactions:twelveMonths')}</div>
                    <div className="radioButton"><input type="radio" id="-1" name="period" value="-1" checked={this.state.period === "-1"}
                        onChange={(e) => this.handlePeriod(e)} /></div>
                    <div className="radioButtonText">{t('transactions:chosen')}</div>
                </div>
                <table className="date">
                    <tbody>
                        <tr>
                            <td>{t('memberDetails:openingAt')}
                                <div style={{paddingLeft: "10px", display: "inline"}}>
                                    <DatePicker style={{marginLeft: "5px"}}
                                    dateFormat="dd/MM/yyyy"
                                    selected={new Date(moment(this.state.startDate))}
                                    onChange={date => this.handleStartDate(date)}/>
                                </div>
                            </td>
                            <td>{t('memberDetails:closingAt')}
                                <div style={{paddingLeft: "10px", display: "inline"}}>
                                    <DatePicker style={{marginLeft: "10px"}}
                                    dateFormat="dd/MM/yyyy"
                                    selected={new Date(moment(this.state.endDate))}
                                    onChange={date => this.handleEndDate(date)}/>
                                </div>
                            </td> 
                            <td className="viewButton"><button className="refresh" id="view" onClick={e => this.handleViewAndExport(e)}>{t('adviserHomePage:view')}</button></td>
                            
                            <td className="exportButton">
                                <button  className="refresh" id="export" onClick={e => this.handleViewAndExport(e)}>Export CSV</button>
                                <CSVLink className="link" style={{paddingLeft:"5px", color: "white"}}  
                                    ref={this.exportRef}
                                    filename="Transactions.csv" 
                                    data={this.state.transactionsCSV}>{t('adviserHomePage:export')}
                                </CSVLink>
                            </td>
                            

                        </tr>
                    </tbody>
                </table>
                <div style={{marginTop: "20px", marginBottom: "20px"}}>
                    <ul id="tabs" className="transactionTabs tabs">
                        <li style={{paddingLeft: "330px"}}>{t('transactions:fundTransactions')}</li>
                    </ul>

    	            <FundTransactions {...this.props}/> 
                    
                </div>
            </div>
            
        )
    }
}

TransactionHistory.propTypes={
    transactionsCSV: PropTypes.array 
}

export default TransactionHistory;